module.exports = __webpack_public_path__ + "static/media/Remus Lupin 1.fb32a828.jpg";